import { useState, useEffect } from "react";
import DynamicCard from "./gallery_cards/dynamic_cards";
import "./gallerypage.css";

function Gallerypage() {
  const [galleryData, setGalleryData] = useState([]);
  const [openBoxes, setOpenBoxes] = useState({});
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  // Load config.json once
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch gallery only after config is loaded
  useEffect(() => {
    if (!config) return;

    const fetchGallery = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.GET_GALLERY}`);
        const result = await res.json();

        if (result.success) {
          // Group by year
          const grouped = {};
          result.gallery.forEach((item) => {
            if (!grouped[item.year]) grouped[item.year] = [];
            grouped[item.year].push(item);
          });

          // Convert to array & sort years (latest → oldest)
          const data = Object.entries(grouped)
            .sort(([a], [b]) => b - a) // descending order
            .map(([year, items], idx) => ({
              id: idx + 1,
              title: year,
              data: items,
            }));

          setGalleryData(data);

          // Init all boxes open
          const initState = {};
          data.forEach((ws) => (initState[ws.id] = true));
          setOpenBoxes(initState);
        } else {
          console.error(result.message);
        }
      } catch (err) {
        console.error("Error fetching gallery:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [config]);

  const toggleOpen = (id) => {
    setOpenBoxes((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  if (loading) return <p>Loading gallery...</p>;

  return (
    <div className="gallery_container">
      {galleryData.map(({ id, title, data }) => (
        <div className="gallery_box" key={id}>
          <h2
            className={`gallery_box_title ${openBoxes[id] ? "open" : "closed"}`}
            onClick={() => toggleOpen(id)}
          >
            {title}
            <i
              className={`fas fa-chevron-down arrow-icon ${
                openBoxes[id] ? "rotated" : ""
              }`}
            />
          </h2>
          <div
            className={`gallery_box_content ${
              openBoxes[id] ? "visible" : "hidden"
            }`}
          >
            <DynamicCard cardsData={data} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default Gallerypage;
